
window.$.bridget ??= require("jquery-bridget");
window.Flickity = require("flickity");
$.bridget("flickity", Flickity, $);